import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var BellIcon = function BellIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.283 17.171",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: fillColor,
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1.3")
  }, [h("path", {
    "stroke-width": "1.202",
    d: "M5.699 14.057v.573a1.943 1.943 0 0 0 3.886 0v-.569"
  }), h("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.141",
    d: "M6.276.724a5.015 5.015 0 0 0-1.852.876 6.571 6.571 0 0 0-2.231 5.039v2.513L.884 \n            11.026a1.638 1.638 0 0 0 .982  2.548 31.038 31.038 0 0 0 11.558.011 1.637 1.637 0 0 0 \n            .975-2.546l-1.318-1.887V6.639c-.005-.457-.083-3.458-2.307-5.094A4.965 4.965 \n            0 0 0 8.998.724a6.089 6.089 0 0 0-2.722 0Z"
  })]));
};